import getApi from '../../../api/apisauceConfig'
import { PendingFollowPatientPayload } from '../../../model/Doctolib'

export const createDoctolibPendingPatientData = (
  id: number,
  pendingPatientPayload: PendingFollowPatientPayload,
) => getApi().post<void>(`/patients/${id}/pending_changes/batch`, pendingPatientPayload)
